import { render, staticRenderFns } from "./Authorizer.vue?vue&type=template&id=9b005616&scoped=true&"
import script from "./Authorizer.vue?vue&type=script&lang=js&"
export * from "./Authorizer.vue?vue&type=script&lang=js&"
import style0 from "./Authorizer.vue?vue&type=style&index=0&id=9b005616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b005616",
  null
  
)

export default component.exports